
  import React from "react"
  import Component from "/zeit/3ed6856d/src/layouts/index.js"
  import data from "/zeit/3ed6856d/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js